<div class="verification-container">
    <h2 class="verification-title">Recuperar contraseña</h2>
    <div class="email-notification">
        <p>Ingrese el correo electrónico con el que registraste tu cuenta y enviaremos un mensaje con instrucciones para
            restablecer tu contraseña</p>
    </div>

    <form [formGroup]="form" (ngSubmit)="verificarCorreo()" class="recovery-form">
        <div class="input-group">
            <input 
                type="email" 
                placeholder="Correo electrónico *" 
                formControlName="email" 
                class="email-input"
            />
            <div *ngIf="registerEmail?.invalid && (registerEmail?.dirty || registerEmail?.touched)"
                class="validation-input-error">
                <p *ngIf="registerEmail?.errors?.['required']">Ingrese correo electrónico</p>
                <p *ngIf="registerEmail?.errors?.['email']">
                    Por favor, ingrese un correo electrónico válido
                </p>
            </div>
            <div *ngIf="errorMessage" class="validation-input-error email-exist">
                <p>{{ errorMessage }}</p>
            </div>
        </div>

        <div class="button-verificar">
            <button class="boton-principal" [disabled]="form.invalid" type="submit">
                Enviar instrucciones
            </button>
        </div>
    </form>

    <div class="navigate-to">
        ¿No tienes cuenta? <a (click)="navigateToRegister()">Regístrate aquí</a>
    </div>
</div>